import { SelectableModel } from '@/types/message.type'

export const BUTTON_CLICK = '[LinqAlpha] Button Click'
export const SHOW = '[LinqAlpha] Show'
export const PAGE_VIEW = '[LinqAlpha] Page View'

export const VIEW_PRODUCT_UPDATES = 'View Product Updates'
export const CLICK_PRODUCT_UPDATES_LOAD_MORE = 'Click Product Updates Load More'

// Custom Events
export const CONTINUE_WITH_GOOGLE = 'continue_with_github'
export const CONTINUE_WITH_GITHUB = 'continue_with_google'
export const SIGN_OUT = 'sign_out'
export const SAMPLE_QUESTION = 'sample_question'
export const NEW_CHAT = 'new_chat'
export const NEW_RMS_CHAT = 'new_rms_chat'
export const HISTORY = 'history'
export const VIEW_REFERENCES = 'view_references'
export const PARAGRAPH = 'paragraph'
export const REFRENCE = 'reference'
export const QUERY_UNDERSTANDING = 'query_understanding'
export const COPY = 'copy'
export const SHARE = 'share'
export const SHARE_ANSWER = 'share_answer'
export const THUMBS_DOWN = 'thumbs_down'
export const RELATED_QUESTION = 'related_question'
export const EXPORT_EXCEL = 'export_excel'
export const DOLLER_SIGN_SELECTOR = 'doller_sign_selector'
export const AT_SIGN_SELECTOR = 'at_sign_selector'
export const MODEL_SELECT = 'model_select'
export const ASK_ABOUT_TRANSCRIPT = 'ask_about_tanscript'
export const SET_UP_WATCHLIST = 'set_up_watchlist'
export const FILTER_OPEN = 'filter_open'
export const FILTER_APPLY = 'filter_apply'
export const EARNINGS_ONBOARDING_NEXT_STEP = 'earnings_onboarding_next_step'
export const EARNINGS_ONBOARDING_PREV_STEP = 'earnings_onboarding_prev_step'
export const EARNINGS_ONBOARDING_SELECT_COUNTRY = 'earnings_onboarding_select_country'
export const EARNINGS_ONBOARDING_SELECT_STOCKS = 'earnings_onboarding_select_stocks'
export const EARNINGS_UPCOMING_SELECT_EVENT = 'earnings_upcoming_select_event'
export const EARNINGS_FIRST_TAKE_CLICK = 'earnings_first_take_click'
export const EARNINGS_SUMMARY_CLICK = 'earnings_summary_click'
export const EARNINGS_DOWNLOAD_ICS_CLICK = 'earnings_download_ics_click'
export const EARNINGS_LIVE_URL_CLICK = 'earnings_live_url_click'
export const EARNINGS_PRESS_RELEASE_URL_CLICK = 'earnings_press_release_url_click'
export const EARNINGS_TRANSCRIPT_URL_CLICK = 'earnings_transcript_url_click'
export const EARNINGS_WATCHLIST_SELECT_SECTOR = 'earnings_watchlist_select_sector'
export const WORKFLOW_LIST_CLICK = 'workflow_list_click'
export const EXECUTE_WORKFLOW = 'execute_workflow'
export const EXECUTE_CATALYST = 'execute_catalyst'
export const EXECUTE_COMPANY_PAGE = 'execute_company_page'
export const EXECUTE_TREND = 'execute_trend'
export const EXECUTE_OWNERSHIP = 'execute_ownership'
export const EXECUTE_SCREENER = 'execute_screener'
export const REFINE_SCREENER = 'refine_screener'
export const EXECUTE_SCREENER_SEARCH = 'execute_screener_search'
export const EXECUTE_CALL_SUMMARIZER = 'execute_call_summarizer'
export const EXECUTE_STRUCTURED_DATA = 'execute_structured_data'
export const SELECT_TICKER_FROM_TREND_SEARCH = 'select_ticker_from_trend_search'
export const MEETING_AGENT_EXTRACT_TEXT = 'meeting_agent_extract_text'
export const MEETING_AGENT_BOOK = 'meeting_agent_book'
export const VIEW_MEETING_AGENT_BLOCKED_LINK = 'View Meeting Agent Blocked Link'
export const MEETING_AGENT_OPEN_TRANSCRIPT = 'meeting_agent_open_transcript'
export const MEETING_AGENT_DOWNLOAD_AUDIO = 'meeting_agent_download_audio'
export const CLICK_MEETING_AGENT = 'Click Meeting Agent'
export const EXECUTE_PRIMER = 'execute_primer'
export const EXECUTE_PULSE_CHECK = 'execute_pulse_check'

// Form IDs
export const chatFormID = (model: SelectableModel) => `chat_form_${model}`
export const landingChatFormID = (model: SelectableModel) => `landing_chat_form_${model}`
export const conversationFormId = (id: string) => `conversation_form_${id}`
export const SIGN_IN_FORM = 'sign_in_form'
export const SIGN_UP_FORM = 'sign_up_form'
export const CHECK_SSO_FORM = 'check_sso_form'
export const FORGOT_PASSWORD_FORM = 'forgot_password_form'
export const RESET_PASSWORD_FORM = 'reset_password_form'
export const SET_INITIAL_PASSWORD_FORM = 'set_initial_password_form'
export const FEEDBACK_FORM = 'feedback_form'
export const TREND_SEARCH_FORM = 'trend_search_form'

// Jongwon Make Event
export const CLICK_RECOMMENDED_KEYWORD = 'Click Recommended Keyword'
export const CLICK_RECOMMENDED_QUESTION = 'Click Recommended Question'
export const CLICK_TICKER_OPTION = 'Click Ticker Option'

// call calendar events
export const OPEN_CALENDAR_PANEL = 'Open Calendar Panel'
export const CLICK_CALENDAR_ACTION = 'Click Calendar Action'
export const TOGGLE_CALENDAR_PREFERENCE = 'Toggle Calendar Preference'
export const CLICK_CALENDAR_PREFERENCE = 'Click Calendar Preference'

// catalyst events
export const CLICK_CATALYST_SUMMARY_SECTOR = 'Click Catalyst Summary Sector'

// Company Page Events
export const VIEW_COMPANY_PAGE = 'View Company Page'
export const OPEN_COMPANY_PAGE_PANEL = 'Open Company Page Panel'
export const CLICK_COMPANY_PAGE_TAB = 'Click Company Page Tab'
export const TOGGLE_COMPANY_PAGE_PANEL = 'Toggle Company Page Panel'
export const CLICK_COMPANY_PAGE_SUBTAB = 'Click Company Page Subtab'
export const CLICK_COMPANY_PAGE_WIDGET = 'Click Company Page Widget'
export const CLICK_COMPANY_PAGE_SHARE = 'Click Company Page Share'
export const CLICK_COMPANY_PAGE_EXPORT = 'Click Company Page Export'

// Reddit Report Events
export const VIEW_REDDIT_REPORT = 'View Reddit Report'
export const OPEN_REDDIT_REPORT_PANEL = 'Open Reddit Report Panel'
export const TOGGLE_REDDIT_REPORT_PANEL = 'Toggle Reddit Report Panel'
export const CLICK_REDDIT_REPORT_WIDGET = 'Click Reddit Report Widget'

// Feedback Events
export const CLICK_FEEDBACK = 'Click Feedback'

// Primer Events
export const CLICK_PRIMER_EXPORT = 'Click Primer Export'

// Watchlist Agent Events
export const OPEN_WATCHLIST_AGENT_MODAL = 'Open Watchlist Agent Modal'
export const SUBMIT_WATCHLIST_AGENT_INPUT = 'Submit Watchlist Agent Input'
export const CONFIRM_WATCHLIST_AGENT_SUGGESTION = 'Confirm Watchlist Agent Suggestion'
export const CREATE_WATCHLIST_GROUP = 'Create Watchlist Group'
export const VIEW_WATCHLIST_GROUP = 'View Watchlist Group'
export const SELECT_WATCHLIST_GROUP = 'Select Watchlist Group'
export const UPDATE_WATCHLIST_GROUP = 'Update Watchlist Group'
export const DELETE_WATCHLIST_GROUP = 'Delete Watchlist Group'
export const TOGGLE_WATCHLIST_GROUP_VISIBILITY = 'Toggle Watchlist Group Visibility'
export const CLICK_WATCHLIST_BULK_ACTION = 'Click Watchlist Bulk Action'

// Watchlist Edit Modal Events
export const OPEN_WATCHLIST_EDIT_MODAL = 'Open Watchlist Edit Modal'
export const SAVE_WATCHLIST_EDIT_MODAL = 'Save Watchlist Edit Modal'
export const CLICK_WATCHLIST_EDIT_MODAL_AGENT = 'Click Watchlist Edit Modal Agent'

// Onboarding Agent Events
export const VIEW_ONBOARDING_AGENT = 'View Onboarding Agent'
export const SUBMIT_ONBOARDING_AGENT_MESSAGE = 'Submit Onboarding Agent Message'
export const CLICK_ONBOARDING_AGENT_SAMPLE_QUESTION = 'Click Onboarding Agent Sample Question'
export const COMPLETE_ONBOARDING_AGENT = 'Complete Onboarding Agent'
export const SKIP_ONBOARDING_AGENT = 'Skip Onboarding Agent'
export const CLICK_ONBOARDING_TICKER_ACTION = 'Click Onboarding Ticker Action'
export const CLICK_ONBOARDING_GROUP_TICKER_MOVE = 'Click Onboarding Group Ticker Move'
export const CLICK_ONBOARDING_GROUP_EDIT = 'Click Onboarding Group Edit'
export const SUBMIT_ONBOARDING_EXECUTION = 'Submit Onboarding Execution'
export const VIEW_ONBOARDING_PHASE = 'View Onboarding Phase'
export const VIEW_ONBOARDING_WATCHLIST_COMPLETE = 'View Onboarding Watchlist Complete'
export const VIEW_ONBOARDING_BRIEFING_PROPOSAL = 'View Onboarding Briefing Proposal'
export const CLICK_ONBOARDING_SET_UP_BRIEFING = 'Click Onboarding Set Up Briefing'
export const SKIP_ONBOARDING_BRIEFING = 'Skip Onboarding Briefing'
export const COMPLETE_ONBOARDING_BRIEFING = 'Complete Onboarding Briefing'

// Briefing Agent Events
export const VIEW_BRIEFING_AGENT_PAGE = 'View Briefing Agent Page'
export const OPEN_BRIEFING_AGENT_MODAL = 'Open Briefing Agent Modal'
export const CLOSE_BRIEFING_AGENT_MODAL = 'Close Briefing Agent Modal'
export const CLICK_BRIEFING_AGENT_CARD = 'Click Briefing Agent Card'
export const SELECT_BRIEFING_AGENT_SOURCE = 'Select Briefing Agent Source'
export const CHANGE_BRIEFING_AGENT_FREQUENCY = 'Change Briefing Agent Frequency'
export const ADD_BRIEFING_AGENT_TICKER = 'Add Briefing Agent Ticker'
export const REMOVE_BRIEFING_AGENT_TICKER = 'Remove Briefing Agent Ticker'
export const COMPLETE_BRIEFING_AGENT_SETUP = 'Complete Briefing Agent Setup'
export const TOGGLE_BRIEFING_AGENT_STATUS = 'Toggle Briefing Agent Status'
export const DELETE_BRIEFING_AGENT = 'Delete Briefing Agent'
export const CLICK_BRIEFING_AGENT_AI_SUGGEST = 'Click Briefing Agent AI Suggest'
export const SELECT_BRIEFING_AGENT_AI_SUGGESTION = 'Select Briefing Agent AI Suggestion'
export const SELECT_BRIEFING_AGENT_GROUP = 'Select Briefing Agent Group'
export const SELECT_BRIEFING_AGENT_TEMPLATE = 'Select Briefing Agent Template'
export const SEARCH_BRIEFING_AGENT_HISTORY = 'Search Briefing Agent History'
export const FILTER_BRIEFING_AGENT_HISTORY = 'Filter Briefing Agent History'
export const CLICK_BRIEFING_AGENT_HISTORY_PAGE = 'Click Briefing Agent History Page'
export const TOGGLE_BRIEFING_AGENT_HISTORY_PANEL = 'Toggle Briefing Agent History Panel'
export const CLICK_BRIEFING_AGENT_HISTORY_CARD = 'Click Briefing Agent History Card'
export const CLICK_BRIEFING_AGENT_HISTORY_BUTTON = 'Click Briefing Agent History Button'
export const SELECT_BRIEFING_AGENT_SKILL = 'Select Briefing Agent Skill'
export const CLICK_BRIEFING_AGENT_PREVIEW = 'Click Briefing Agent Preview'
export const OPEN_BRIEFING_AGENT_FULL_EDITOR = 'Open Briefing Agent Full Editor'
export const UNDO_BRIEFING_AGENT_AI_SUGGESTION = 'Undo Briefing Agent AI Suggestion'
export const CLICK_BRIEFING_AGENT_DISCARD_DIALOG = 'Click Briefing Agent Discard Dialog'
export const CLICK_WATCHLIST_CREATE_BRIEFING = 'Click Watchlist Create Briefing'
export const OPEN_WATCHLIST_PASTE = 'Open Watchlist Paste'
export const RESOLVE_WATCHLIST_PASTE = 'Resolve Watchlist Paste'
export const COMMIT_WATCHLIST_PASTE = 'Commit Watchlist Paste'

// Briefing Feedback Loop Events (PRD #2500)
// Server-fired events: emitted by Rails via Amplitude::TrackBriefingFeedbackJob.
// Client-fired events: emitted from React via useAmplitudeTracking.
// Labels are shared so funnels join cleanly.
export const VIEW_BRIEFING_FEEDBACK_LANDING = 'View Briefing Feedback Landing'
export const CLICK_BRIEFING_FEEDBACK_THUMB = 'Click Briefing Feedback Thumb'
export const SUBMIT_BRIEFING_FEEDBACK_RATING = 'Submit Briefing Feedback Rating'
export const SELECT_BRIEFING_FEEDBACK_CHIP = 'Select Briefing Feedback Chip'
export const SKIP_BRIEFING_FEEDBACK_CHIP = 'Skip Briefing Feedback Chip'
export const SUBMIT_BRIEFING_FEEDBACK_COMMENT = 'Submit Briefing Feedback Comment'
export const SUBMIT_BRIEFING_HIGHLIGHT_FEEDBACK = 'Submit Briefing Highlight Feedback'
export const APPLY_BRIEFING_TEMPLATE_FILTER = 'Apply Briefing Template Filter'
export const PAUSE_BRIEFING_SCHEDULE = 'Pause Briefing Schedule'
export const REDUCE_BRIEFING_FREQUENCY = 'Reduce Briefing Frequency'
export const CLICK_THINGS_YOU_MIGHT_MISS = 'Click Things You Might Miss'
export const CSM_BRIEFING_CHURN_ALERT = 'CSM Briefing Churn Alert'

// Analytics Trending Events
export const CLICK_ANALYTICS_TRENDING_QUESTION = 'Click Analytics Trending Question'

// Analytics Skill Events — main-page skill folder launchpad (PRD #3680)
export const CLICK_ANALYTICS_SKILL = 'Click Analytics Skill'

// Analytics Stop Generation Events
export const CLICK_ANALYTICS_STOP_GENERATION = 'Click Analytics Stop Generation'

// OAuth Authorize Events
export const VIEW_OAUTH_AUTHORIZE = 'View OAuth Authorize'
export const CLICK_OAUTH_AUTHORIZE = 'Click OAuth Authorize'

// SharePoint Consent Events
export const VIEW_SHAREPOINT_CONSENT_COMPLETE = 'View SharePoint Consent Complete'

// Vault Upload Events
export const TRIGGER_VAULT_UPLOAD_FALLBACK = 'Trigger Vault Upload Fallback'

// Claude Workspace Paste-as-File Events
export const CREATE_CLAUDE_WORKSPACE_PASTED_TEXT_ATTACHMENT =
  'Create Claude Workspace Pasted Text Attachment'
export const CREATE_CLAUDE_WORKSPACE_PASTED_IMAGE_ATTACHMENT =
  'Create Claude Workspace Pasted Image Attachment'

// Storage Vault Folder Events
export const CLICK_STORAGE_CREATE_FOLDER = 'Click Storage Create Folder'
export const CLICK_STORAGE_MOVE_FILE = 'Click Storage Move File'

// Recents / Chat Search Events (Recents Step 1)
export const OPEN_CHAT_SEARCH = 'Open Chat Search'
export const CLICK_CHAT_SEARCH_CONVERSATION = 'Click Chat Search Conversation'
export const CLICK_CHAT_SEARCH_NEW_CHAT = 'Click Chat Search New Chat'
export const VIEW_RECENTS = 'View Recents'
export const CLICK_RECENTS_CONVERSATION = 'Click Recents Conversation'
export const TOGGLE_RECENTS_FAVORITE = 'Toggle Recents Favorite'
export const RENAME_RECENTS_CONVERSATION = 'Rename Recents Conversation'
export const DELETE_RECENTS_CONVERSATION = 'Delete Recents Conversation'
export const OPEN_RECENTS_ORGANIZE_MODAL = 'Open Recents Organize Modal'
export const APPLY_RECENTS_ORGANIZE = 'Apply Recents Organize'

// Artifacts (artifact library & sharing)
export const VIEW_ARTIFACTS = 'View Artifacts'
export const CLICK_ARTIFACTS_TAB = 'Click Artifacts Tab'
export const OPEN_ARTIFACT = 'Open Artifact'
export const CLICK_ARTIFACTS_SHARE = 'Click Artifacts Share'
export const CLICK_FAVORITE_CONVERSATION = 'Click Favorite Conversation'

// RMS Viewer Events (LIN-650)
// Broad by design: one event covers every save the reference viewer offers, and
// `source` / `format` carry which viewer and which file it was, so adding the
// transcript PDF later extends the attributes instead of splitting the event.
export const CLICK_RMS_VIEWER_DOWNLOAD = 'Click RMS Viewer Download'

// Investment Profile Gate Events (PRD linq-alpha-server#3892)
export const VIEW_INVESTMENT_PROFILE_GATE = 'View Investment Profile Gate'
export const COMPLETE_INVESTMENT_PROFILE_STEP = 'Complete Investment Profile Step'
export const SUBMIT_INVESTMENT_PROFILE = 'Submit Investment Profile'
export const CLOSE_INVESTMENT_PROFILE_GATE = 'Close Investment Profile Gate'

// Event Map V1 (COV-315 instrumentation spec). The two WARS-qualified actions
// are Submit Ask and Copy Question; everything else is diagnostic.
export const CLICK_EVENT_MAP_NAV = 'Click Event Map Nav'
export const VIEW_EVENT_MAP_FEED = 'View Event Map Feed'
export const SELECT_EVENT_MAP_TAB = 'Select Event Map Tab'
export const LOAD_MORE_EVENT_MAP_EVENTS = 'Load More Event Map Events'
export const CHANGE_EVENT_MAP_FILTER = 'Change Event Map Filter'
export const IMPRESS_EVENT_MAP_CARD = 'Impress Event Map Card'
export const OPEN_EVENT_MAP_CARD = 'Open Event Map Card'
export const OPEN_EVENT_MAP_RELATED_NEWS = 'Open Event Map Related News'
export const EXPAND_EVENT_MAP_CAUSAL_CHAIN = 'Expand Event Map Causal Chain'
export const COPY_EVENT_MAP_QUESTION = 'Copy Event Map Question'
export const OPEN_EVENT_MAP_SOURCE = 'Open Event Map Source'
export const EXPAND_EVENT_MAP_SOURCES = 'Expand Event Map Sources'
export const SUBMIT_EVENT_MAP_FEEDBACK = 'Submit Event Map Feedback'
export const CLICK_EVENT_MAP_SAVE = 'Click Event Map Save'
export const CLICK_EVENT_MAP_SHARE = 'Click Event Map Share'
export const OPEN_EVENT_MAP_GRAPH = 'Open Event Map Graph'
export const VIEW_EVENT_MAP_GRAPH_TIP = 'View Event Map Graph Tip'
export const DISMISS_EVENT_MAP_GRAPH_TIP = 'Dismiss Event Map Graph Tip'
export const REFRESH_EVENT_MAP_FEED = 'Refresh Event Map Feed'
export const SEARCH_EVENT_MAP_FEED = 'Search Event Map Feed'

export const PIN_ARTIFACT = 'Pin Artifact'
export const UNPIN_ARTIFACT = 'Unpin Artifact'
export const SEARCH_ARTIFACTS = 'Search Artifacts'
export const RENAME_ARTIFACT = 'Rename Artifact'
export const OPEN_ARTIFACT_CONVERSATION = 'Open Artifact Conversation'
export const TOGGLE_ARTIFACTS_PINNED_FILTER = 'Toggle Artifacts Pinned Filter'
export const LOAD_ARTIFACTS_PAGE = 'Load Artifacts Page'
export const VIEW_ARTIFACTS_SEARCH_RESULTS = 'View Artifacts Search Results'
export const VIEW_ARTIFACTS_PIN_TIP = 'View Artifacts Pin Tip'
export const DISMISS_ARTIFACTS_PIN_TIP = 'Dismiss Artifacts Pin Tip'
